import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './pages/App';
import SignIn from './pages/signin';
import CreateUser from './pages/CreateUser';
import { signOut, getCurrentUser } from '@aws-amplify/auth';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {Amplify} from 'aws-amplify';
import awsconfig from './aws-exports';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
Amplify.configure(awsconfig);
const queryClient = new QueryClient();
const Index = () => {
 const [isUserSignedIn, setIsUserSignedIn] = useState(null);


useEffect(() => {
  const checkUserSignedIn = async () => {
    const forceLogout = sessionStorage.getItem('forceLogout');
    if (forceLogout) {
      sessionStorage.removeItem('forceLogout');
      console.log("Forced logout due to page close");
      await signOut(); // This time async is safe
      setIsUserSignedIn(false);
      return;
    }

    try {
      await getCurrentUser();
      setIsUserSignedIn(true);
    } catch {
      setIsUserSignedIn(false);
    }
  };

  checkUserSignedIn();
}, []);
 const SignOut = async () => {
   await signOut();
   setIsUserSignedIn(false);
   window.location.href = '/';
 }

 const handleSignIn = () => {
  setIsUserSignedIn(true);
 };

 const handleUserCreated = () => {
  console.log('User created successfully!');
 };

 return (
  <QueryClientProvider client={queryClient}>
   <Router>
     {isUserSignedIn !== null && (
       <Routes>
         <Route path="/" element={isUserSignedIn ? <App SignOut={SignOut} /> : <SignIn onSignin={handleSignIn}/>} />
         <Route path="/app" element={isUserSignedIn ? <App SignOut={SignOut} /> : <Navigate to="/" />} />
       </Routes>
     )}
   </Router>
   </QueryClientProvider>
 );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Index />);
